import { Row, Col } from 'antd';
import { Header } from './Header';

interface ContentProps {
	children: JSX.Element | JSX.Element[];
}

export function Content({ children }: Readonly<ContentProps>) {
	return (
		<Row>
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>{children}</Col>
		</Row>
	);
}
